import React from 'react'
import { getFromSession } from '../../helpers/GenericHelpers';
import { RoutesEnum } from '../../models/RoutesModel';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import LoginPage from '../../pages/LoginPage';

const ProtectedRoute = () => {
  const location = useLocation()

  const user = getFromSession('user_name')

  if (!user || user === '' || user === null) {
    window.location.href = `/${RoutesEnum.LOGIN}`;
  } else {
      if (location?.pathname) return <Outlet />;
      else window.location.href = `/${RoutesEnum.NOT_FOUND}`;
    return <></>;
  }

  return <></>
}

export default ProtectedRoute